import { breakpoints, Container } from "@brightagency/headstart-common";
import React from "react";
import styled from "styled-components";
import { ContentBuilderType } from "../../../constants/types/acf/content-builder-types";
import { ContentBuilder } from "../ContentBuilder";

const Outer = styled.div`
    background-color: white;
    margin: 50px 0 75px;

    ${breakpoints.large} {
        margin: 60px 0 75px;
    }
`;

const CustomContainer = styled(Container)`
    max-width: 900px;
`;

interface Props {
    content: ContentBuilderType;
}

export const PageContent: React.FC<Props> = props => {
    return (
        <Outer>
            <CustomContainer>
                <ContentBuilder content={props.content} />
            </CustomContainer>
        </Outer>
    );
};
